import * as pc from 'playcanvas';

// Maximum number of levels
export const MAX_LEVELS = 10;

// Level configurations for each boss
export const LEVEL_CONFIG = {
    1: {
        name: "Shadow Demon",
        bossColor: new pc.Color(0.15, 0.05, 0.2),
        bossGlowColor: new pc.Color(1, 0.1, 0.1),
        bossHealth: 150,
        bossSpeed: 2.0,
        attackCooldown: 1.2,
        telegraphTime: 0.6,
        bossDamage: 20,
        arena: 'tech'
    },
    2: {
        name: "Frost Giant",
        bossColor: new pc.Color(0.1, 0.2, 0.4),
        bossGlowColor: new pc.Color(0.3, 0.8, 1.0),
        bossHealth: 200,
        bossSpeed: 2.2,
        attackCooldown: 1.1,
        telegraphTime: 0.55,
        bossDamage: 22,
        arena: 'ice'
    },
    3: {
        name: "Inferno King",
        bossColor: new pc.Color(0.3, 0.05, 0.0),
        bossGlowColor: new pc.Color(1, 0.5, 0.0),
        bossHealth: 250,
        bossSpeed: 2.4,
        attackCooldown: 1.0,
        telegraphTime: 0.5,
        bossDamage: 25,
        arena: 'fire'
    },
    4: {
        name: "Storm Titan",
        bossColor: new pc.Color(0.1, 0.15, 0.25),
        bossGlowColor: new pc.Color(0.4, 0.8, 1.0),
        bossHealth: 320,
        bossSpeed: 2.6,
        attackCooldown: 0.9,
        telegraphTime: 0.45,
        bossDamage: 28,
        arena: 'storm'
    },
    5: {
        name: "Void Emperor",
        bossColor: new pc.Color(0.05, 0.0, 0.1),
        bossGlowColor: new pc.Color(0.8, 0.2, 1.0),
        bossHealth: 400,
        bossSpeed: 2.8,
        attackCooldown: 0.8,
        telegraphTime: 0.4,
        bossDamage: 30,
        arena: 'void'
    },
    6: {
        name: "Crystal Golem",
        bossColor: new pc.Color(0.2, 0.4, 0.35),
        bossGlowColor: new pc.Color(0.3, 1.0, 0.8),
        bossHealth: 450,
        bossSpeed: 2.5,
        attackCooldown: 0.85,
        telegraphTime: 0.45,
        bossDamage: 32,
        arena: 'crystal'
    },
    7: {
        name: "Jungle Beast",
        bossColor: new pc.Color(0.15, 0.25, 0.05),
        bossGlowColor: new pc.Color(0.4, 1.0, 0.2),
        bossHealth: 480,
        bossSpeed: 3.2,
        attackCooldown: 0.7,
        telegraphTime: 0.4,
        bossDamage: 30,
        arena: 'jungle'
    },
    8: {
        name: "Ocean Kraken",
        bossColor: new pc.Color(0.05, 0.15, 0.25),
        bossGlowColor: new pc.Color(0.2, 0.6, 1.0),
        bossHealth: 520,
        bossSpeed: 2.8,
        attackCooldown: 0.75,
        telegraphTime: 0.4,
        bossDamage: 35,
        arena: 'ocean'
    },
    9: {
        name: "Solar Phoenix",
        bossColor: new pc.Color(0.4, 0.2, 0.0),
        bossGlowColor: new pc.Color(1.0, 0.8, 0.2),
        bossHealth: 550,
        bossSpeed: 3.5,
        attackCooldown: 0.6,
        telegraphTime: 0.35,
        bossDamage: 38,
        arena: 'solar'
    },
    10: {
        name: "Nightmare Lord",
        bossColor: new pc.Color(0.1, 0.0, 0.1),
        bossGlowColor: new pc.Color(1.0, 0.0, 0.5),
        bossHealth: 600,
        bossSpeed: 3.8,
        attackCooldown: 0.5,
        telegraphTime: 0.3,
        bossDamage: 40,
        arena: 'nightmare'
    }
};

// Arena display names
export const ARENA_NAMES = {
    tech: 'CYBER ARENA',
    ice: 'FROZEN PEAKS',
    fire: 'INFERNO PIT',
    storm: 'THUNDER SPIRE',
    void: 'THE VOID',
    crystal: 'CRYSTAL CAVERN',
    jungle: 'WILD JUNGLE',
    ocean: 'DEEP ABYSS',
    solar: 'SOLAR TEMPLE',
    nightmare: 'REALM OF NIGHTMARES'
};

// Arena shape and size configurations
// shape: 'circle', 'square', 'hexagon', 'octagon', 'rectangle', 'oval'
// size: multiplier for arena dimensions (1.0 = original size of 22 units)
export const ARENA_SHAPES = {
    tech: { shape: 'circle', size: 1.0, innerSize: 0.82 },           // Classic circular arena
    ice: { shape: 'hexagon', size: 1.3, innerSize: 0.85 },           // Large hexagonal frozen arena
    fire: { shape: 'octagon', size: 1.15, innerSize: 0.8 },          // Octagonal pit
    storm: { shape: 'rectangle', size: 1.4, aspectRatio: 1.5, innerSize: 0.85 }, // Wide rectangular arena
    void: { shape: 'circle', size: 1.5, innerSize: 0.75 },           // Huge circular void
    crystal: { shape: 'hexagon', size: 1.25, innerSize: 0.82 },      // Hexagonal crystal cavern
    jungle: { shape: 'oval', size: 1.35, aspectRatio: 1.4, innerSize: 0.85 },    // Oval jungle clearing
    ocean: { shape: 'circle', size: 1.45, innerSize: 0.8 },          // Large circular ocean floor
    solar: { shape: 'octagon', size: 1.3, innerSize: 0.82 },         // Octagonal sun temple
    nightmare: { shape: 'square', size: 1.5, innerSize: 0.78 }       // Huge square nightmare realm
};

// Level intro colors
export const LEVEL_COLORS = {
    1: '#ff4444',  // Red - Shadow Demon
    2: '#44aaff',  // Blue - Frost Giant
    3: '#ff8800',  // Orange - Inferno King
    4: '#66ddff',  // Cyan - Storm Titan
    5: '#aa44ff',  // Purple - Void Emperor
    6: '#44ffaa',  // Teal - Crystal Golem
    7: '#88ff44',  // Green - Jungle Beast
    8: '#4488ff',  // Deep Blue - Ocean Kraken
    9: '#ffdd44',  // Gold - Solar Phoenix
    10: '#ff44aa' // Pink - Nightmare Lord
};
